import React from 'react';
import NavigationArrow from '../../common/navigation-arrow';

const ScreenNavigation = ({to, onClick, type = 'next', isVisible = true}) => {
	if (!isVisible || ('undefined' === typeof onClick && 'undefined' === typeof to)) {
		return null;
	}

	return (
		<div className={`screen-navigation screen-navigation-${type}`}>
			<NavigationArrow {...{to, onClick, type}} />
		</div>
	);
}

export default ScreenNavigation;
